export default "__VITE_ASSET__DECVrP1E__"